import {
  ArrowCircleRightIcon,
  ViewGridAddIcon,
} from "@heroicons/react/outline";
import { teamsData } from "../../utils/teamsData";

const TeamsCard = () => {
  return (
    <div className="mt-16 md:mt-0 lg:mt-16">
      <div className="space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-5">
        <div className="lg:grid lg:grid-cols-2 lg:gap-5">
          {teamsData.map(({ id, desc, title, Icon }, index) => (
            <div
              key={id}
              className="group space-y-2 bg-white p-3 rounded-md hover:scale-105  hover:transition-all transform duration-100 hover:ease-in-out hover:shadow-lg hover:cursor-pointer shadow-md py-5"
            >
              <Icon
                className={`h-16 py-3 group-hover:text-indigo-500 ${
                  index === 1 &&
                  "border-2 border-gray-700 group-hover:border-indigo-500 px-3 rounded-lg"
                }`}
              />
              <div className=" group-hover:text-indigo-500">
                <h1 className="font-bold text-xl sm:text-2xl font-mono">
                  {title}
                </h1>
                <p className="mt-3">{desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div>
          <div className="group bg-white px-4 py-5 flex flex-col justify-around rounded-md hover:scale-105  hover:transition-all transform duration-100 hover:ease-in-out hover:shadow-lg hover:cursor-pointer shadow-md">
            <div>
              <ViewGridAddIcon className=" h-10 group-hover:text-indigo-500" />
            </div>

            <div className="flex items-center justify-between group-hover:text-indigo-500">
              <h1 className="text-lg font-bold font-mono">
                Memento For Ennterprice
              </h1>
              <ArrowCircleRightIcon className="h-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamsCard;
